import { useApolloClient } from '@apollo/client';
import { SelectOption } from 'common/types/select-option';
import { DISTINCT_CAR_KEYS_QUERIES } from 'data/CarKeyQueries.graphql';
import { DistinctCarKey, useDistinctCarKeysLazyQuery } from 'graphql/generated';

export const useDistinctCarKeysLazy = () => {
  const client = useApolloClient();
  const [runQuery] = useDistinctCarKeysLazyQuery();

  const loadModels = (make: string) => {
    // console.log('runQuery for make', make);
    runQuery({
      variables: { make: true, model: true, filters: [{ field: 'make', strVal: make }] },
    });
  };

  const getModels = (make: string) => {
    const data = client.readQuery({
      query: DISTINCT_CAR_KEYS_QUERIES,
      variables: { make: true, model: true, filters: [{ field: 'make', strVal: make }] },
    });
    const makeModels: DistinctCarKey[] = data?.distinctCarKeys || [];
    const result = makeModels.filter(x => x.make === make);
    // console.log(`getModels for make: ${make}`, result);
    return result;
  };

  return { loadModels, getModels };
};
